import { Filters } from './Filters';
import {
  DynamicAuctionFilters,
  SearchFilters,
} from 'shared/types/api/getAuctions';
import { styled } from '@mui/material/styles';

const SidebarContainer = styled('div')(
  ({ theme }) => `
  background: ${theme.palette.common.white};
  height: fit-content;
  padding: ${theme.spacing(3, 2, 1, 2)};
  border-right: 1px solid ${theme.palette.divider};`,
);

const Sidebar = ({
  dynamicFilters,
  searchFilters,
}: SidebarPropsType): JSX.Element => (
  <SidebarContainer>
    <Filters dynamicFilters={dynamicFilters} searchFilters={searchFilters} />
  </SidebarContainer>
);

type SidebarPropsType = {
  isCompact: boolean;
  dynamicFilters: DynamicAuctionFilters;
  searchFilters: SearchFilters;
};

export default Sidebar;
